module.exports = __webpack_public_path__ + "img/tarj-2.69b7673f.svg";